/* eslint-disable @typescript-eslint/ban-types */

export interface Methods<T> {
  /**
   * get serialized object stored in the local storage
   * @param key key to get item for
   */
  getItem(key: string): T;
  /**
   * update storage data with given key and object of value
   * @param key key to serialize storage on
   * @param value value to overwrite previous item inside the store
   */
  setItem(key: string, value: T): void;
  /**
   * remove an item from the storage
   * @param key key to remove
   */
  removeItem(key: string): void;
  /**
   * clear the storage from all items
   */
  clear(): void;
}

/**
 * Get browser storage utility helpers
 * @param storage storage support type (usually `localStorage` or `sessionStorage`). Defaults to "sessionStorage"
 */
export function storage<T extends object>(storage: Storage = sessionStorage): Methods<T> {
  const getItem = function <T>(key: string) {
    if (!key) {
      return {} as T;
    }
    const current = storage.getItem(key);
    return JSON.parse(current ?? '{}') as T;
  };

  const setItem = function <T>(key: string, value: T) {
    if (!key) {
      return;
    }
    const prevState = getItem<T>(key);
    const newStorage: T = {
      ...prevState,
      ...value
    };
    storage.setItem(key, JSON.stringify(newStorage));
  };

  const removeItem = function (key: string) {
    key && storage.removeItem(key);
  };

  const clear = function () {
    storage.clear();
  };

  return {
    getItem,
    setItem,
    removeItem,
    clear
  };
}
